import React from 'react'

const ColorText = ({ color, style, ...props }) => (
  <span style={{ ...style, color }} {...props} />
)

export default ColorText



// WEBPACK FOOTER //
// ./src/components/ColorText.js